import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { useTranslations } from "@vocab/react";
import { Box, IconTick, Link, Inline, Text } from "braid-design-system";
import { useLink } from "../../../ApacCandidateFooter/components/Accordion/Accordion.mjs";
import { useApacCandidateHeaderContext, isDivider } from "../../ApacCandidateHeader.mjs";
import { DIVIDER_PADDING } from "../ResponsiveDropdownMenu/ResponsiveDropdownMenu.mjs";
import { TabBadge } from "../TabBadge/TabBadge.mjs";
import { translations } from "../../../../ApacCandidateHeader/components/Tabs/.vocab/index.mjs";
import { invisible, hide, link, isActive } from "./ResponsiveTab.css.mjs";
const getTabTextTone = ({
  tabItem,
  isSubItem
}) => {
  if (tabItem.objectType === "TabItem" && tabItem.tone) {
    return tabItem.tone;
  }
  return isSubItem && !tabItem.isActive ? "secondary" : "neutral";
};
const getTabTextWeight = (tabItem) => {
  if (tabItem.objectType === "TabItem" && tabItem.weight) {
    return tabItem.weight;
  }
  return tabItem.isActive ? "strong" : "regular";
};
const ResponsiveTab = ({
  tabItem,
  isSubItem,
  isMenuOpen = true,
  shouldApplyIconForActiveItem
}) => {
  const { injectLinkContextToData } = useLink();
  const { setIsMenuOpen } = useApacCandidateHeaderContext();
  const { t } = useTranslations(translations);
  switch (tabItem.objectType) {
    case "TabItem":
    case "TabItemLanguage":
      const tone = getTabTextTone({
        tabItem,
        isSubItem
      });
      const weight = getTabTextWeight(tabItem);
      const IconComponent = tabItem.icon;
      const ActiveIcon = shouldApplyIconForActiveItem && /* @__PURE__ */ jsx(Box, { className: { [invisible]: !tabItem.isActive }, children: /* @__PURE__ */ jsx(IconTick, {}) });
      return /* @__PURE__ */ jsx(
        Link,
        {
          href: tabItem.href,
          className: [
            {
              [isActive]: tabItem.isActive && !isSubItem,
              [link]: isMenuOpen,
              [hide]: !isMenuOpen
            }
          ],
          onClick: () => {
            var _a;
            setIsMenuOpen(false);
            (_a = tabItem == null ? void 0 : tabItem.handleClick) == null ? void 0 : _a.call(tabItem);
          },
          data: injectLinkContextToData(
            { ...tabItem.linkContext, isExpanded: true },
            { automation: tabItem.linkContext.source }
          ),
          children: /* @__PURE__ */ jsx(
            Box,
            {
              cursor: "pointer",
              display: "flex",
              paddingLeft: isSubItem ? "large" : "small",
              paddingY: "medium",
              alignItems: "center",
              children: /* @__PURE__ */ jsxs(Inline, { space: "xsmall", alignY: "center", children: [
                /* @__PURE__ */ jsx(Text, { tone, weight, children: /* @__PURE__ */ jsxs(Inline, { space: "xsmall", children: [
                  IconComponent && /* @__PURE__ */ jsx(IconComponent, {}),
                  ActiveIcon && ActiveIcon,
                  /* @__PURE__ */ jsx(Fragment, { children: tabItem.text })
                ] }) }),
                Boolean(tabItem.objectType === "TabItem" && tabItem.isNew) ? /* @__PURE__ */ jsx(TabBadge, { tone: "positive", bleedY: true, children: t("New") }) : null
              ] })
            }
          )
        }
      );
    case "TabItemWithCustomComponent":
      const customComponentIsDivider = isDivider(tabItem.customComponent);
      return /* @__PURE__ */ jsx(
        Box,
        {
          display: isMenuOpen ? "block" : "none",
          paddingLeft: isSubItem ? "gutter" : "small",
          paddingRight: customComponentIsDivider && isSubItem ? "gutter" : "none",
          paddingY: customComponentIsDivider ? DIVIDER_PADDING : "none",
          children: /* @__PURE__ */ jsx(tabItem.customComponent, {})
        }
      );
  }
};
export {
  ResponsiveTab
};
